module.exports = __webpack_public_path__ + "img/d201007-1.44121fc7.jpg";